import React, { useCallback } from "react";
import { DESKTOP_HEADER_NAV_KEYS } from "@/constants/navigationKeys";
import { navItemsConfig } from "@/components/navigation/config/navItemsConfig";
import DesktopHeaderNavItem from "@/components/navigation/desktopHeaderNavItem";
import { buildPathWithLocale } from "@/utils/languageVersions/localeHelpers/pathWithLocale";
import { generatePath, useParams } from "react-router-dom";
import { useCartSummary } from "@/components/cart/hooks/useCartSummary";
import { useGetMenuIdQuery } from "@/graphql/menuId/menuId.hooks";
import { getMenuTypeFromUrl } from "@/components/cart/helpers/cartEvents";

interface DesktopHeaderNavProps {
  onOpenSelected: () => void;
}

const DesktopHeaderNav: React.FC<DesktopHeaderNavProps> = ({
  onOpenSelected,
}) => {
  const { locale, menuId, branchId, typeMenu } = useParams<{
    locale?: string;
    menuId?: string;
    branchId?: string;
    typeMenu?: string;
  }>();
  const menuTypeEnum = getMenuTypeFromUrl(typeMenu);
  const { data: menuIdData } = useGetMenuIdQuery({
    skip: !branchId || !menuTypeEnum,
    variables: {
      branchId: Number(branchId),
      typeMenu: menuTypeEnum,
    },
  });

  const menuData = menuId ? menuId : menuIdData?.menu?.id;

  const { hasItems } = useCartSummary(Number(menuData));

  const handleAction = useCallback(
    (actionId?: string) => {
      if (actionId === "selected") {
        onOpenSelected?.();
      }
    },
    [onOpenSelected]
  );

  return (
    <nav className="d-flex align-items-center gap-6">
      {DESKTOP_HEADER_NAV_KEYS.map((navKey) => {
        const item = navItemsConfig[navKey];

        if (item.type === "action") {
          return (
            <DesktopHeaderNavItem
              key={item.key}
              item={item}
              onAction={() => handleAction(item.actionId)}
              showDot={item.key === "selected" && hasItems}
            />
          );
        }

        const resolvedPath = (() => {
          if (!branchId || !typeMenu) return item.path;

          if (menuId && item.path) {
            return generatePath(item.path, {
              menuId,
              branchId,
              typeMenu,
            });
          }

          if (!menuId && item.activePath) {
            return generatePath(item.activePath, {
              branchId,
              typeMenu,
            });
          }

          return item.path;
        })();
        const path = buildPathWithLocale(locale ?? "", resolvedPath);

        return <DesktopHeaderNavItem key={item.key} item={item} path={path} />;
      })}
    </nav>
  );
};

export default DesktopHeaderNav;
